import React, { useEffect, useRef } from 'react';

import AuthButton from './AuthButton';
import AuthCodeInput from './AuthCodeInput';
import AuthCodeResendControl from './AuthCodeResendControl';
import { AuthFormMessage } from './AuthFlow';

export default function AuthCodeForm({
  code,
  codeErrorMessageId,
  codeLength,
  disabled,
  error,
  formMessageId,
  hasCodeError,
  isResending,
  isSubmitting,
  onCodeChange,
  onResend,
  onSubmit,
  pendingLabel,
  resendCooldownSeconds,
  showInlineCodeError,
  submitLabel,
}) {
  const formRef = useRef(null);
  const lastAutoSubmittedCodeRef = useRef(null);
  const inputErrorMessageId = showInlineCodeError ? codeErrorMessageId : formMessageId;

  useEffect(
    function autoSubmitCompleteCodeEffect() {
      if (code.length !== codeLength) {
        lastAutoSubmittedCodeRef.current = null;
        return;
      }
      if (disabled || lastAutoSubmittedCodeRef.current === code) return;

      lastAutoSubmittedCodeRef.current = code;
      formRef.current?.requestSubmit();
    },
    [code, codeLength, disabled],
  );

  return (
    <form ref={formRef} className="flex w-full flex-col" onSubmit={onSubmit}>
      <input type="hidden" name="code" value={code} readOnly />
      <AuthCodeInput
        code={code}
        codeLength={codeLength}
        disabled={disabled}
        errorMessageId={inputErrorMessageId}
        hasError={hasCodeError}
        onChange={onCodeChange}
        showInlineError={showInlineCodeError}
      />
      <div className="mt-12 flex w-full flex-col gap-3">
        <AuthFormMessage error={showInlineCodeError ? null : error} id={formMessageId} />
        <AuthButton disabled={disabled || code.length !== codeLength}>{isSubmitting ? pendingLabel : submitLabel}</AuthButton>
      </div>
      <AuthCodeResendControl
        cooldownSeconds={resendCooldownSeconds}
        disabled={disabled || isResending || resendCooldownSeconds > 0}
        isResending={isResending}
        onResend={onResend}
      />
    </form>
  );
}
